const CHANNELS = {
    RWD: 'rwd',
    WEB: 'web'
};

export { CHANNELS };
